import React from 'react'

import cx from 'classnames'

import utilityStyles from '../../styles/utility.module.css'
import styles from './styles.module.css'

interface Props {
  children?: React.ReactNode
  'data-ocweb-id': string
}

const BaseCard: React.FC<Props> = ({ children, 'data-ocweb-id': dataOcwebId }) => (
  <div
    className={cx(styles.baseCard, utilityStyles.darkGrayColor, utilityStyles.smFontSize)}
    data-ocweb-id={dataOcwebId}>
    <div className={styles.cardContent}>{children}</div>
  </div>
)

export default BaseCard
